import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';

import ListSkeleton from '../../../../../components/Skeletons/ListSkeleton';
import LogPresenter from '../../../../../presenters/LogPresenter';
import { useFetchStatus } from '../../../../../utils/fetchStatusUtils';

import Log from './components/Log';

const LogsTable = (props) => {
  const { logs, loadingState } = props;

  const { isFulfilled } = useFetchStatus(loadingState);

  if (!isFulfilled) {
    return <ListSkeleton height={15} width={500} />;
  }

  const isLogsEmpty = isEmpty(logs);

  if (isLogsEmpty) {
    return <div className="empty-table">No data</div>;
  }

  return (
    <div className="modal-table">
      <table className="tables">
        <thead>
          <tr>
            <th className="date-cell">Date</th>
            <th>Event type</th>
            <th>Meta</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log) => {
            return <Log key={log.id} log={log} />;
          })}
        </tbody>
      </table>
    </div>
  );
};

export default LogsTable;

LogsTable.propTypes = {
  logs: PropTypes.arrayOf(LogPresenter.shape()),
  loadingState: PropTypes.string.isRequired,
};

LogsTable.defaultProps = {
  logs: [],
};
